<!-- =========================================================================================
  File Name: User.vue
  Description: User page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

    <div id="page-user-list" class="vx-card p-6">

      <!-- Searchs-->
      <vx-card ref="filterCard" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
        <div class="vx-row">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">ログインID</label>
             <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="loginIDFilter"/>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">メールアドレス</label>
            <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="メールアドレス（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="emailFilter"/>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">氏名</label>
            <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="氏名（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="nameFilter"/>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">状態</label>
            <v-select class="sm:mr-4 sm:w-3/5 w-3/4 sm:order-normal order-3 sm:mt-0 mt-4" :options="stateFlgFilterOptions" clearable :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="stateFlgFilter">
              <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full flex flex-wrap items-end justify-end div-search-bnt">
              <vs-button icon="search" @click="pageNumber = 1; searchUserWithOrder(); ids = []" class="search_icon mr-6 sm:mr-3">検索 </vs-button>
          </div>
        </div>
      </vx-card>

        <!-- Title and Buttons Action -->
        <div class="text-title">
          <span>利用者一覧</span>
        </div>
        <vs-row class="pl-2">
          <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="6">
            <span class="pr-2">表示件数:</span>
            <div class="vx-col md:w-24 w-full">
              <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :options="paginationOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="paginationPageSize">
                <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
              </v-select>
            </div>
          </vs-col>
          <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="6">
            <vs-button :disabled="ids.length > 0 ? false:true" color="danger" icon="delete" @click="activeDelete = true">削除</vs-button>
            <vs-button color="success" icon="person_add" @click="setUpCreate">登録</vs-button>
            <vs-button :disabled="ids.length > 0 ? false:true" color="warning" icon="mail" @click="resetPasswordUser">パスワード設定依頼</vs-button>
          </vs-col>
        </vs-row>

      <vs-popup id="dialogDelete" title="利用者の削除" :active.sync="activeDelete" button-close-hidden>
        <div>
          <span>
            選択した利用者を削除しますか？
          </span>
        </div>
        <div class="flex justify-end mt-4">
            <vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>
            <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
        </div>
      </vs-popup>

      <!-- Create and Edit Dialog -->
      <vs-popup id="dialogUpdate" :title="title" :active.sync="activePopup" button-close-hidden>
        <div>
          <div>
            <vx-card title="利用者詳細"
            card-background ="rgb(240, 238, 241)"
            height="420px"
            class="pb-2"
            style="font-size: 12px">
              <div>
                <vs-row>
                  <vs-col class="flex items-center" vs-w="3">
                    <span class="pt-2">ログインID<span style="color: red" v-if="!submited">*</span></span>
                  </vs-col>
                  <vs-col vs-w="9">
                    <vs-row>
                      <vs-input :disabled="title == '利用者情報更新'"  v-validate.immediate="'required|login_id'" maxlength="15" name="ログインID" v-model="login_id" class="w-full mb-2"/>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-offset="3">
                    <span v-show="submited && title != '利用者情報更新' " class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("ログインID") | convertError }}</span>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col class="flex items-center" vs-w="3">
                    <span>メールアドレス<span style="color: red">*</span></span>
                  </vs-col>
                  <vs-col vs-w="9">
                    <vs-row>
                      <vs-input v-validate.immediate="'required|email|override-email'" maxlength="256" name="メールアドレス" v-model="email" class="w-full mb-2"/>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-offset="3">
                    <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("メールアドレス") | convertError }}</span>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col class="flex items-center" vs-w="3">
                    <span>電話番号</span>
                  </vs-col>
                  <vs-col vs-w="9">
                    <vs-row>
                      <vs-input v-validate.immediate="'numeric'" name="電話番号" v-model="phone_number" maxlength="15" class="w-full mb-2"/>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-offset="3">
                    <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("電話番号") | convertError }}</span>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col class="flex items-center" vs-w="3">
                    <span>氏名<span style="color: red">*</span></span>
                  </vs-col>
                  <vs-col vs-w="9">
                    <vs-row>
                      <vs-col vs-offset="0" vs-w="4">
                        <vs-input v-validate.immediate="'required'" placeholder="姓" name="姓" maxlength="64" v-model="family_name" class="w-full mb-2"/>
                      </vs-col>
                      <vs-col vs-offset="2" vs-w="4">
                        <vs-input v-validate.immediate="'required'" placeholder="名" name="名" maxlength="64" v-model="given_name" class="w-full mb-2"/>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row class="mb-2">
                  <vs-col vs-offset="3">
                    <span v-show="submited" class="text-danger font-size-info">{{ errors.first("姓") ?  errors.first("姓"):errors.first("名") | convertError }}</span>
                  </vs-col>
                </vs-row>
                <vs-row style="font-size: 12px">
                  <vs-col class="flex items-center" vs-w="3">
                    <span>状態:</span>
                  </vs-col>
                  <vs-row vs-w="9">
                    <div v-for="(item,index) in stateFlgOptions" :key=index>
                      <div v-if="state_flg == 0 || title != '利用者情報更新'" class="mr-4">
                        <!-- <vs-radio disabled color="grey" v-model="state_name" :vs-value="item" class="mx-1 pr-1">{{item}}</vs-radio> -->
                        <input disabled type="radio" v-model="state_name" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                        <span>{{item}}</span>
                      </div>
                      <div v-else class="mr-4">
                        <!-- <vs-radio v-model="state_name" :vs-value="item" class="mx-1 pr-1">{{item}}</vs-radio> -->
                        <input type="radio" v-model="state_name" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                        <span>{{item}}</span>
                      </div>
                    </div>
                  </vs-row>
                </vs-row>
              </div>
            </vx-card>
          </div>
          <vs-card
          class="mt-6 bg-role-color"
          >
              <vs-tabs v-model="checkTab">
                <vs-tab label="閲覧可能お問い合わせメール">
                  <div class="con-tab-ejemplo">
                    <vs-row style="font-size: 12px">
                      <span v-if="getFullMailServersName.length == 0">データがありません</span>
                      <vs-row v-for="(mailServer,index) in getFullMailServersName" :key="index">
                        <vs-col vs-w="8">
                          <vs-checkbox v-model="mst_mail_server" :vs-value="mailServer.id" class="mx-1 pb-1">{{mailServer.name}}</vs-checkbox>
                        </vs-col>
                        <vs-col vs-w="4">
                          <vs-checkbox v-model="read_only_mail_server" :vs-value="mailServer.id" class="mx-1 pb-1">閲覧</vs-checkbox>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                  </div>
                </vs-tab>
                <vs-tab label="閲覧可能電話">
                  <div class="con-tab-ejemplo">
                    <vs-row style="font-size: 12px">
                      <span v-if="getFullTelephonesName.length == 0">データがありません</span>
                      <vs-row v-for="(telephoneServer,index) in getFullTelephonesName" :key="index">
                        <vs-col vs-w="8">
                          <vs-checkbox v-model="mst_tetephone_server" :vs-value="telephoneServer.id" class="mx-1 pb-1">{{telephoneServer.name}}</vs-checkbox>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                  </div>
                </vs-tab>
              </vs-tabs>
          </vs-card>
          <div style="display: flex; justify-content: flex-end" class="pt-4">
            <vs-button v-if="title != '利用者情報更新'" @click="actionCreate" :disabled="!validateForm && submited" icon="person_add" color="success" style="padding: 8px; margin-right: 5px;height: 37px">登録</vs-button>
            <vs-button v-else @click="actionUpdate" :disabled="!validateForm" icon="assignment" color="success" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
            <vs-button v-if="title == '利用者情報更新'" @click="resetPasswordUser" icon="mail" color="warning" style="padding: 8px; margin-right: 5px;height: 37px">パスワード設定依頼</vs-button>
            <vs-button v-if="title == '利用者情報更新'" @click="activeDelete = true" icon="delete" color="danger" style="padding: 8px; margin-right: 5px;height: 37px">削除</vs-button>
            <vs-button @click="activePopup = false;" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
          </div>
        </div>
      </vs-popup>

      <!-- AgGrid Table -->
      <ag-grid-vue
        id="myGrid"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table database"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :domLayout="domLayout"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
        @sortChanged="onSortChangedEvent"
        :overlayNoRowsTemplate="noRowsTemplate"
        :detailRowAutoHeight="true"
      >
      </ag-grid-vue>

      <div style="position: relative">
      <!-- ITEMS PER PAGE -->
        <div>
            <div class="flex items-center justify-between">
              <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
            </div>
        </div>
      <!-- pagination -->
        <vs-pagination
            :total="totalPages"
            v-model="currentPage"
            :max="7"
            class="pr-10 pt-10"
            />
    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect       from 'vue-select'
import EventBus      from '../../../EventBus'
import {mapActions, mapGetters} from 'vuex'

// Cell Renderer
import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererActions
  },
  data () {
    return {
      activePopup:     false,
      activeDelete:    false,
      submited:        false,
      title:           '',
      id:              null,
      ids:             [],
      login_id:        null,
      phone_number:    null,
      password:        null,
      email:           null,
      given_name:      null,
      family_name:     null,
      display_order_mail_sever:     null,
      display_order_telephone_sever:     null,
      state_name:      '無効',
      mst_mail_server: [],
      read_only_mail_server:       [],
      state_flg:        0,

      // Filter Options
      loginIDFilter:   null,
      emailFilter:     null,
      nameFilter:      null,
      stateFlgFilter:  '...',
      stateFlgFilterOptions: [
        '...','有効','無効'
      ],
      stateFlgOptions: [
        '有効','無効'
      ],

      paginationOptions: [
        10, 20, 30, 50
      ],

      //SortServer
      orderBy: 'id',
      orderDir: 'asc',

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 170,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          sort: 'asc',
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'ログインID',
          field: 'login_id',
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'メールアドレス',
          field: 'email',
          filter: true,
          width: 225,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '氏名',
          field: 'name',
          filter: true,
          width: 160,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '電話番号',
          field: 'phone_number',
          filter: true,
          width: 170,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '状態',
          field: 'state_name',
          filter: true,
          width: 140,
          unSortIcon: true,
          comparator: (val1, val2) => val1-val2,
          suppressMovable: true,
        },
        {
          headerName: 'パスワード',
          field: 'verify',
          filter: true,
          comparator: (val1, val2) => {
            if (val1 == val2) return 0;
            return (val1 > val2) ? 1 : -1;
          },
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '',
          field: 'transactions',
          width: 130,
          cellRendererFramework: 'CellRendererActions',
          unSortIcon: false,
          suppressMovable: true,
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererActions
      },
      //todo setting telephone permission
      mst_tetephone_server: [],
      checkTab: 0,
    }
  },
  watch: {
    paginationPageSize(val){
      this.setPagination(val);
    },
    'activePopup': function () {
      this.checkTab = 0;
    }
  },
  computed: {
    ...mapGetters({
      getFullMailServersName: 'mailServer/getFullMailServersName',
      getUser:            'userManagement/getUser',
      getFullTelephonesName: 'telephoneServer/getTelephones',
    }),
    validateForm(){
      return !this.errors.any()
    },
    usersData () {
      let usersData = []
      this.$store.state.userManagement.users.forEach((element) => {
        let state_name = ''
        if(element.state_flg == 1) state_name = '有効'
        else state_name =  '無効'

        let verify = ''
        if(element.password == '') verify = '未設定'
        else verify = '設定済'
        usersData.push(Object.assign({name: element.family_name + ' ' + element.given_name, state_name: state_name, verify: verify}, element));
      });
      return usersData
    },
    totalPages () {
      return parseInt(this.$store.state.userManagement.infoDB.totalPage)
    },
    totalRow(){
      return parseInt(this.$store.state.userManagement.infoDB.totalRow)
    },
    currentPage: {
      get () {
        return this.pageNumber
      },
      async set (val) {
        this.pageNumber = val
        await this.searchUserWithOrder();
        this.ids = []
        this.gridApi.paginationGoToPage(val-1)
      }
    },
    state(){
      if(this.stateFlgFilter == '無効') return 0
      else if(this.stateFlgFilter == '有効') return 1
      else return;
    }
  },
  methods: {
    ...mapActions({
      addUser:        'userManagement/addUser',
      updateUser:     'userManagement/updateUser',
      fetchUser:      'userManagement/fetchUser',
      fetchUsers:     'userManagement/fetchUsers',
      removeRecords:  'userManagement/removeRecords',
      getFullMailServers: 'mailServer/getFullMailServers',
      getTetephoneServers: 'telephoneServer/getListTelephone',
      resetPassword:  'userManagement/resetPassword'
    }),
    onSelectionChanged() {
      this.ids = this.gridApi.getSelectedRows().map(user => user.id)
    },
    onSortChangedEvent(event){
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function(column){
        if (column.getSort()){
          root.orderDir = column.getSort()
          root.orderBy  = column.getColId()
          root.searchUserWithOrder();
          return;
        }
      });
    },
    searchUserWithOrder(){
      // change before sort/search => *now: database hasn't field: name, state_name and verify
      if(this.orderBy == 'name') this.orderBy = 'family_name'
      if(this.orderBy == 'state_name') this.orderBy = 'state_flg'
      if(this.orderBy == 'verify') this.orderBy = 'password'
      //fetchUser with condition
      this.fetchUsers({orderBy: this.orderBy, orderDir: this.orderDir, login_id: this.loginIDFilter, email: this.emailFilter, name: this.nameFilter, state_flg: this.state, limit: this.paginationPageSize, page: this.pageNumber})
    },
    setUpCreate(){
      // clear all fields before create
      this.state_name       = '無効',
      this.id               = null,
      this.login_id         = null,
      this.password         = null,
      this.phone_number     = null,
      this.email            = null,
      this.given_name       = null,
      this.family_name      = null,
      this.mst_mail_server  = null,
      this.state_flg        = 0,
      this.submited         = false,
      this.mst_mail_server  = []
      this.title            = '利用者情報登録'
      this.activePopup      = true
      this.read_only_mail_server = [];
      this.mst_tetephone_server = [];
    },
    async actionCreate(){
      if(!this.validateForm){
        this.submited = true; // first: no show error => after submited: show error
      }
      else{
        let user = {
          login_id:     this.login_id,
          phone_number: this.phone_number,
          email:        this.email,
          given_name:   this.given_name,
          family_name:  this.family_name,
          mail_svr:     this.mst_mail_server,
          read_only:      this.read_only_mail_server,
          telephone_svr: this.mst_tetephone_server,
        }
        await this.addUser(user)
        this.activePopup = false
        await this.searchUserWithOrder()
      }
    },
    async actionUpdate(){
        // check user has password with state_name
        if(this.password){
          if(this.state_name == '有効') this.state_flg = 1
          if(this.state_name != '有効') this.state_flg = 9
        }
        else this.state_flg = 0
        await this.updateUser(
            {
              id:             this.id,
              login_id:       this.login_id,
              phone_number:   this.phone_number,
              email:          this.email,
              given_name:     this.given_name,
              family_name:    this.family_name,
              mail_svr:       this.mst_mail_server,
              state_flg:      this.state_flg,
              read_only:      this.read_only_mail_server,
              telephone_svr:  this.mst_tetephone_server,
              display_order_mail_sever:  this.display_order_mail_sever,
              display_order_telephone_sever:  this.display_order_telephone_sever,
          })
      this.activePopup = false
      this.ids = []
      await this.searchUserWithOrder()
    },
    async resetPasswordUser() {
      await this.resetPassword(this.ids);

      //if reset password in dialog update => not delete user
      if(this.title == '利用者情報登録'){
        this.ids = []
        this.gridApi.deselectAll()
      }
    },
    async confirmDelete(){
      await this.deleteSelect();
      this.activeDelete = false
      this.activePopup = false
    },
    async deleteSelect () {
      await this.removeRecords(this.ids)
      this.gridApi.deselectAll()
      this.ids = []
      await this.searchUserWithOrder()
    },
    async resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.loginIDFilter  = null,
      this.nameFilter     = null,
      this.emailFilter    = null,
      this.stateFlgFilter = '...'
      this.ids = []
      await this.searchUserWithOrder()
      this.$refs.filterCard.removeRefreshAnimation()
    },
    async setPagination(val){
      this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1
      await this.searchUserWithOrder();
      this.ids = []
    },
    editListener(id) {
      this.fetchUser(id)
        .then(
            user => {
          this.id           = user.id
          this.state_flg    = user.state_flg
          this.state_name   = user.state_flg == 1 || parseInt(user.state_flg) == 1 ? '有効':'無効'
          this.login_id     = user.login_id
          this.password     = user.password
          this.email        = user.email
          this.phone_number = user.phone_number
          this.given_name   = user.given_name
          this.family_name  = user.family_name
          this.display_order_mail_sever  = user.displayOrderMailSever
          this.display_order_telephone_sever  = user.displayOrderPhoneSever
          this.mst_mail_server = user.mailServerIds
          this.read_only_mail_server = user.readOnlymailServerIds
          this.mst_tetephone_server = user.telephoneServerIds
          this.title        = '利用者情報更新'
          this.submited     = true
          this.activePopup  = true
        })
    },
    deleteListener(id) {
      this.activeDelete = true
    },
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    EventBus.$on('editRecord', this.editListener)
    EventBus.$on('deleteRecord', this.deleteListener);
    // save paginationSize to sessionStorage (when fresh browser)
    const root = this
    window.addEventListener('beforeunload', function(){
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
    })
  },
  async created () {
    await this.searchUserWithOrder();
    await this.getFullMailServers({orderBy: 'mail_srv_name', orderDir: 'asc'});
    await this.getTetephoneServers();
  },
  beforeMount(){
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
  },
  updated(){
    // set paginationPageSize = 10 (default) when change page/route
    sessionStorage.setItem("paginationPageSize", 10)
    // calc number startRow and endRow
    this.$nextTick(()=>{
      if(!this.$store.state.loading && this.usersData.length > 0){
        this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
        if(this.usersData.length == this.paginationPageSize) this.endRow = this.pageNumber*this.paginationPageSize
        else this.endRow = this.paginationPageSize*this.pageNumber + this.usersData.length - this.paginationPageSize
      }
      if(this.usersData.length == 0){
        this.endRow = 0
        this.startRow = 0
      }
    });
  },
  beforeDestroy(){
    EventBus.$off('editRecord', this.editListener);
    EventBus.$off('deleteRecord', this.deleteListener);
  },
  destroyed(){
    // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
    document.getElementById('dialogDelete').style.display = 'none'
    document.getElementById('dialogUpdate').style.display = 'none'
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/user-management.scss";

.bg-role-color{
  background-color: #f0eef1;
}
.role-cursor{
  cursor: pointer;
}
.role-active{
  background-color: #ffffff;
}
</style>
